export type IToast = {
  title: string
  body: string
  type: ToastType
  duration?: number
  autohide?: boolean
}

export enum ToastType {
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  Danger = 'danger',
}

export type LiveMessage = {
  title: string
  description: string
  severity: 'error' | 'warning' | 'info'
  customers?: string[]
  stages?: string[]
  alwaysShow?: boolean
}
